import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Aguardando from '../common/template/aguardando';
import { MapLeaflet } from "../common/mapLeaflet/MapLeaflet";
import Cookies from 'js-cookie';
import consts from '../consts';
import iconeBandeira from '../assets/images/icone_bandeira.png';
import iconeViagemAberta from '../assets/images/icone_viagem_aberta.png';
import iconeRelogio from '../assets/images/icone_relogio.png';
import iconeCaminhaoVerde from '../assets/map/marker_truck_direita_success.png';
import iconeCaminhaoVermelho from '../assets/map/marker_truck_direita_danger.png';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';

import { 
	setModoTela, setFiltro, getListaFronteiras, getListaNegociadores, getListaOperacoes, getLista, 
	getListaOcorrencias, gerarPdfListadoEmbarqueLocalizado, gerarPdfListadoEmbarqueRN, 
	gerarPdfEstadoEmbarqueFrontera, gerarExcel
} from './linehaulActions';
import { registrarAcesso } from '../analiseAcesso/analiseAcessoActions';
import Select from '../common/form/select';
import SelectNovo from '../common/form/selectNovo';
import SwitchVertical from '../common/form/switchVertical';
import ReportsArquivo from '../reportsArquivo/reportsArquivo';
import {
	getLista as getListaArquivos
} from '../reportsArquivo/reportsArquivoActions'
import Excel from '../common/excel/excel';

class Linehaul extends Component {

	state = {
		modoTela: 'lista',
		linhaSelecionada: null,
		pesquisar: '',
		pesquisarAux: '',
		idShippingExpandido: null,
		resumido: true,
		registroModal: null,
		registroModalOcorrencia: null,
		listaFavoritos: JSON.parse(Cookies.get('shippingsFavoritos') || '[]'),
		listaPeriodo: [
			{ id: 'DATA_PREVISAO_CARGA', valor: 'Previsão Carga' },
			{ id: 'DATA_INICIO_CARGA', valor: 'Chegada Carga' },
			{ id: 'DATA_TERMINO_CARGA', valor: 'Saída Carga' },
			{ id: 'DATA_ENTRADA_ADUANA_ORIGEM', valor: 'Chegada Aduana Origem' },
			{ id: 'DATA_LIBERACAO_ADUANA_ORIGEM', valor: 'Liberação Aduana Origem' },
			{ id: 'DATA_PREV_FRONTEIRA', valor: 'Previsão Fronteira' },
			{ id: 'DATA_ENTRADA_FRONTEIRA', valor: 'Chegada Fronteira' },
			{ id: 'DATA_AUTORIZACAO_INGRESSO_FRONTEIRA', valor: 'Autorização Ingresso fronteira' },
			{ id: 'DT_ENTRADA_ADUANA_FRONT_ORG', valor: 'Chegada Aduana Fronteira Origem' },
			{ id: 'DT_LIBERACAO_ADUANA_FRONT_ORG', valor: 'Liberação Aduana Fronteira Origem' },
			{ id: 'DT_ENTRADA_ADUANA_FRONT_DEST', valor: 'Chegada Aduana Fronteira Destino' },
			{ id: 'DT_LIBERACAO_ADUANA_FRONT_DEST', valor: 'Liberação Aduana Fronteira Destino' },
			{ id: 'DATA_LIBERACAO_FRONTEIRA', valor: 'Liberação Fronteira	' },
			{ id: 'DATA_ENTRADA_ADUANA_DESTINO', valor: 'Chegada Aduana Destino' },
			{ id: 'DATA_LIBERACAO_ADUANA_DESTINO', valor: 'Liberação Aduana Destino' },
			{ id: 'DATA_PREVISAO_DESCARGA', valor: 'Previsão Descarga' },
			{ id: 'DATA_INICIO_DESCARGA', valor: 'Chegada Descarga' },
			{ id: 'DATA_TERMINO_DESCARGA', valor: 'Saída Descarga' }
		],
		filtro: {
			tipo_periodo: 'DATA_PREVISAO_CARGA',
			data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(31)),
			data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()),
			dias_descarga: '0',
			aberto: true,
			finalizado: false,
			semNaoTrack: false,
			comNaoTrack: true,
			/*rumos: [],
			farolAtrasos: [],
			fronteiras: [],
			operacoes: [],
			negociadores: [],
			lote: false,
			classificada: false,
			expressa: false,			
			ocorrenciaAberta: false,
			cavaloEngatado: false,
			somenteCarreta: false,
			semConjunto: false,
			emCD: false,
			semDocumento: false,*/
			nacional: this.props.usuarioCarregado ? this.props.usuarioCarregado.nacional : false,
			internacional: this.props.usuarioCarregado ? this.props.usuarioCarregado.internacional : false,
			ocorrencia_aberta: false,
			transit_time_atraso: false,
			classificada: false
		},
		ordenacao: {
			viagem: 0
		}
	}

    componentWillMount() {
        this.props.getLista(this.state.filtro);

		// setInterval(() => {
		// 	this.props.getLista(this.state.filtro);
		// }, 120000)
    }

	componentDidMount() {
		//Início do registro de Análise Tela
		this.timeEntrouTela = Date.now();
		this.idEntrouTela = setInterval(() => {
			this.props.registrarAcesso('Linehaul', this.props.location.pathname, Date.now() - this.timeEntrouTela);
			this.timeEntrouTela = Date.now();
		}, 60000);
		//Fim do registro de Análise Tela

		document.addEventListener('keydown', this.handleKeyDown);
	}
	
	componentWillUnmount() {
		//Início do encerramento de Análise Tela
		clearInterval(this.idEntrouTela);
		this.props.registrarAcesso('Linehaul', this.props.location.pathname, Date.now() - this.timeEntrouTela);
		//Fim do encerramento de Análise Tela

		document.removeEventListener('keydown', this.handleKeyDown);
	}

	handleKeyDown = (e) => {
		if (e.key === 'Escape') {
			this.setState({ ...this.state, registroModal: null, contatosModal: null, registroModalOcorrencia: null, registroArquivos: null });
		}
	};

    render() {
        return (
            <div>
                <Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.montarTela()}

                </Content>
            </div>
        )
    }

	getOrdem(itemA, itemB, tipo) {

		return tipo == 1 
			? (itemA > itemB ? 1 : -1) 
			: (itemA > itemB ? -1 : 1);

	}			

	filtrar() {

		let lista = this.props.lista

			//FILTRO BUSCA TEXTO
			.filter(item => {

				return !(this.state.pesquisar || '').trim()
					|| (this.state.pesquisar.toUpperCase() || '').split('+').filter(pesquisar => (pesquisar || '').trim()).filter(pesquisar => {
					if (pesquisar
						&& !(`
							${item.rumo}
							${item.viagem}
							${item.identificador}
							${item.documento}
							${item.fatura_comercial}
							${item.ptas}
							${item.cidade_origem}
							${item.kmm}
							${item.duns_number_coleta}
							${item.nome_cliente_origem}
							${item.operacao}
							${FormatUtils.formatarValorTela(item.peso_bruto, 2)}
							${FormatUtils.formatarValorTela(item.volume, 2)}
							${item.cavalo}
							${item.carreta}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao)}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada_carga)}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida_programada)}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida_carga)}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada_troca_nota)}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida_troca_nota)}
							${item.primeiro_transito}
							${item.fronteira}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_fronteira)}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada_fronteira)}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_ingresso_fronteira)}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_liberacao_br)}
							${item.canal}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_apresentacao_ar)}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_liberacao_ar)}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida_guarita)}
							${item.segundo_transito}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_chegada_gm)}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada_aduana)}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_entrega_documento)}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_liberacao_aduana)}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada_descarga)}
							${DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida_descarga)}
							${item.observacao}
							${item.mic}
							${item.rout_id}
						`).toUpperCase().includes(pesquisar)) {
						return false;
					}

					return true;

				}).length > 0;

			});

			if (this.state.ordenacao.rumo) {
				lista.sort((a, b) => this.getOrdem(a.rumo, b.rumo, this.state.ordenacao.rumo));
			} else if (this.state.ordenacao.viagem) {
				lista.sort((a, b) => this.getOrdem(parseInt(a.viagem), parseInt(b.viagem), this.state.ordenacao.viagem));
			} else if (this.state.ordenacao.identificador) {
				lista.sort((a, b) => this.getOrdem(parseInt(a.identificador), parseInt(b.identificador), this.state.ordenacao.identificador));
			} else if (this.state.ordenacao.documento) {
				lista.sort((a, b) => this.getOrdem(a.documento, b.documento, this.state.ordenacao.documento));
			} else if (this.state.ordenacao.fatura_comercial) {
				lista.sort((a, b) => this.getOrdem(a.fatura_comercial, b.fatura_comercial, this.state.ordenacao.fatura_comercial));
			} else if (this.state.ordenacao.ptas) {
				lista.sort((a, b) => this.getOrdem(a.ptas, b.ptas, this.state.ordenacao.ptas));
			} else if (this.state.ordenacao.cidade_origem) {
				lista.sort((a, b) => this.getOrdem(a.cidade_origem, b.cidade_origem, this.state.ordenacao.cidade_origem));
			} else if (this.state.ordenacao.kmm) {
				lista.sort((a, b) => this.getOrdem(a.kmm, b.kmm, this.state.ordenacao.kmm));
			} else if (this.state.ordenacao.duns_number_coleta) {
				lista.sort((a, b) => this.getOrdem(a.duns_number_coleta, b.duns_number_coleta, this.state.ordenacao.duns_number_coleta));
			} else if (this.state.ordenacao.nome_cliente_origem) {
				lista.sort((a, b) => this.getOrdem(a.nome_cliente_origem, b.nome_cliente_origem, this.state.ordenacao.nome_cliente_origem));
			} else if (this.state.ordenacao.operacao) {
				lista.sort((a, b) => this.getOrdem(a.operacao, b.operacao, this.state.ordenacao.operacao));
			} else if (this.state.ordenacao.peso_bruto) {
				lista.sort((a, b) => this.getOrdem(parseFloat(a.peso_bruto, 0), parseFloat(b.peso_bruto, 0), this.state.ordenacao.peso_bruto));
			} else if (this.state.ordenacao.volume) {
				lista.sort((a, b) => this.getOrdem(parseFloat(a.volume, 0), parseFloat(b.volume, 0), this.state.ordenacao.volume));
			} else if (this.state.ordenacao.cavalo) {
				lista.sort((a, b) => this.getOrdem(a.cavalo, b.cavalo, this.state.ordenacao.cavalo));
			} else if (this.state.ordenacao.carreta) {
				lista.sort((a, b) => this.getOrdem(a.carreta, b.carreta, this.state.ordenacao.carreta));
			} else if (this.state.ordenacao.datahora_previsao) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_previsao), new Date(b.datahora_previsao), this.state.ordenacao.datahora_previsao));
			} else if (this.state.ordenacao.datahora_chegada_carga) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_chegada_carga), new Date(b.datahora_chegada_carga), this.state.ordenacao.datahora_chegada_carga));
			} else if (this.state.ordenacao.datahora_saida_programada) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_saida_programada), new Date(b.datahora_saida_programada), this.state.ordenacao.datahora_saida_programada));
			} else if (this.state.ordenacao.datahora_saida_carga) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_saida_carga), new Date(b.datahora_saida_carga), this.state.ordenacao.datahora_saida_carga));
			} else if (this.state.ordenacao.datahora_chegada_troca_nota) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_chegada_troca_nota), new Date(b.datahora_chegada_troca_nota), this.state.ordenacao.datahora_chegada_troca_nota));
			} else if (this.state.ordenacao.datahora_saida_troca_nota) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_saida_troca_nota), new Date(b.datahora_saida_troca_nota), this.state.ordenacao.datahora_saida_troca_nota));
			} else if (this.state.ordenacao.primeiro_transito) {
				lista.sort((a, b) => this.getOrdem(a.primeiro_transito, b.primeiro_transito, this.state.ordenacao.primeiro_transito));
			} else if (this.state.ordenacao.fronteira) {
				lista.sort((a, b) => this.getOrdem(a.fronteira, b.fronteira, this.state.ordenacao.fronteira));
			} else if (this.state.ordenacao.datahora_previsao_fronteira) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_previsao_fronteira), new Date(b.datahora_previsao_fronteira), this.state.ordenacao.datahora_previsao_fronteira));
			} else if (this.state.ordenacao.datahora_chegada_fronteira) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_chegada_fronteira), new Date(b.datahora_chegada_fronteira), this.state.ordenacao.datahora_chegada_fronteira));
			} else if (this.state.ordenacao.datahora_ingresso_fronteira) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_ingresso_fronteira), new Date(b.datahora_ingresso_fronteira), this.state.ordenacao.datahora_ingresso_fronteira));
			} else if (this.state.ordenacao.datahora_liberacao_br) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_liberacao_br), new Date(b.datahora_liberacao_br), this.state.ordenacao.datahora_liberacao_br));
			} else if (this.state.ordenacao.canal) {
				lista.sort((a, b) => this.getOrdem(a.canal, b.canal, this.state.ordenacao.canal));
			} else if (this.state.ordenacao.datahora_apresentacao_ar) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_apresentacao_ar), new Date(b.datahora_apresentacao_ar), this.state.ordenacao.datahora_apresentacao_ar));
			} else if (this.state.ordenacao.datahora_liberacao_ar) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_liberacao_ar), new Date(b.datahora_liberacao_ar), this.state.ordenacao.datahora_liberacao_ar));
			} else if (this.state.ordenacao.datahora_saida_guarita) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_saida_guarita), new Date(b.datahora_saida_guarita), this.state.ordenacao.datahora_saida_guarita));
			} else if (this.state.ordenacao.segundo_transito) {
				lista.sort((a, b) => this.getOrdem(a.segundo_transito, b.segundo_transito, this.state.ordenacao.segundo_transito));
			} else if (this.state.ordenacao.datahora_previsao_chegada_gm) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_previsao_chegada_gm), new Date(b.datahora_previsao_chegada_gm), this.state.ordenacao.datahora_previsao_chegada_gm));
			} else if (this.state.ordenacao.datahora_chegada_aduana) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_chegada_aduana), new Date(b.datahora_chegada_aduana), this.state.ordenacao.datahora_chegada_aduana));
			} else if (this.state.ordenacao.datahora_entrega_documento) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_entrega_documento), new Date(b.datahora_entrega_documento), this.state.ordenacao.datahora_entrega_documento));
			} else if (this.state.ordenacao.datahora_liberacao_aduana) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_liberacao_aduana), new Date(b.datahora_liberacao_aduana), this.state.ordenacao.datahora_liberacao_aduana));
			} else if (this.state.ordenacao.datahora_chegada_descarga) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_chegada_descarga), new Date(b.datahora_chegada_descarga), this.state.ordenacao.datahora_chegada_descarga));
			} else if (this.state.ordenacao.datahora_saida_descarga) {
				lista.sort((a, b) => this.getOrdem(new Date(a.datahora_saida_descarga), new Date(b.datahora_saida_descarga), this.state.ordenacao.datahora_saida_descarga));
			} else if (this.state.ordenacao.observacao) {
				lista.sort((a, b) => this.getOrdem(a.observacao, b.observacao, this.state.ordenacao.datahora_liberacao_br));
			} else if (this.state.ordenacao.mic) {
				lista.sort((a, b) => this.getOrdem(a.mic, b.mic, this.state.ordenacao.mic));
			} else if (this.state.ordenacao.rout_id) {
				lista.sort((a, b) => this.getOrdem(a.rout_id, b.rout_id, this.state.ordenacao.rout_id));
			}
	
			return lista;
	}

	setNovaOrdenacao(atual) {		
		this.setState({
			ordenacao: {
				...atual
			}
		});
	}

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i class="fas fa-sort-amount-down-alt" />;
		} else if (tipo == 2) {
			return <i class="fas fa-sort-amount-up" />;
		} else {
			return null;
		}
	}

	montarTela() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let acessoCliente = this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cliente;
		let indicadores = this.props.usuarioCarregado && (!this.props.usuarioCarregado.acesso_cliente || this.props.usuarioCarregado.track_indicadores);

		let listaFiltrada = this.filtrar();

		const telaMobile = window.innerWidth < 1247;
		
		let setLinhaSelecionada = (id) => {
			this.setState({
				...this.state,
				linhaSelecionada: id
			});
		}

		return (
			<ContentCard>
				
				{this.state.registroModal ? this.modalShipping() : null}
				
				{this.state.registroModalOcorrencia ? this.modalOcorrencia() : null}

				{this.state.contatosModal ? this.modalContatos() : null}

				{this.modalArquivos()}

				<ContentCardHeader paddingBottom={0}>
					
					<Row style={{ display: 'flex', flexDirection: 'row-reverse' }}>
						<Grid cols='12 12 2 2' style={{ textAlign: 'right' }}>

							{this.props.usuarioCarregado && this.props.usuarioCarregado.logo &&
							<img src={`${consts.URL}/${this.props.usuarioCarregado.logo}`} style={{ marginRight: 10, marginTop: 10, height: 55 }} />}
						</Grid>
						
						<Grid cols='12 12 10 10'>
							
							<Row>
								<div style={{ width: 320, marginLeft: 4 }}>
									<div class='form-group'>
										<label htmlFor='pesquisa_geral'>Pesquisar</label>
										<div class='input-group' id='pesquisar'>
											<input 
												type='text'
												name='pesquisa_geral'
												class='form-control datetimepicker-input'
												data-target='#pesquisar'
												placeholder='Adicione + para combinar pesquisas'
												value={this.state.pesquisarAux}
												onChange={e => {
													this.setState({ ...this.state, pesquisarAux: e.target.value });
												}}
												onKeyDown={e => {
													if (e.key === 'Enter') {
														this.setState({ ...this.state, pesquisar: this.state.pesquisarAux });
													}
												}} />
											<div type='button' class='input-group-append' data-target='#pesquisar'>
												<div 
													class='input-group-text'
													onClick={e => {
														this.setState({ ...this.state, pesquisar: this.state.pesquisarAux });
													}}>
													<i class='fas fa-search'></i></div>
											</div>
										</div>
									</div>
								</div>

								<Select
									label='Período'
									minWidth={200}
									maxWidth={200}
									marginLeft={4}
									options={this.state.listaPeriodo}
									placeholder='Selecione'
									naoLimpar
									value={this.state.filtro.tipo_periodo}
									onChange={value => {
										this.setState({
											...this.state,
											filtro: {
												...this.state.filtro,
												tipo_periodo: value
											}
										});
									}} />

								<LabelAndInputMask
									label='Data Inicial' placeholder='Informe a data'
									minWidth={110}
									maxWidth={110}
									marginLeft={4}
									mask='99/99/9999'
									value={this.state.filtro.data_inicial}
									onChange={(data) => {
										this.setState({
											...this.state,
											filtro: {
												...this.state.filtro,
												data_inicial: data.target.value
											}
										});
									}} />

								<LabelAndInputMask
									label='Data Final' placeholder='Informe a data'
									minWidth={110}
									maxWidth={110}
									marginLeft={4}
									mask='99/99/9999'
									value={this.state.filtro.data_final}
									onChange={(data) => {
										this.setState({
											...this.state,
											filtro: {
												...this.state.filtro,
												data_final: data.target.value
											}
										});
									}} />

								<Select
									label='Descarga'
									minWidth={100}
									maxWidth={100}
									marginLeft={4}
									options={this.props.listaDiasDescarga}
									placeholder='Selecione'
									naoLimpar
									value={this.state.filtro.dias_descarga}
									onChange={value => {
										this.setState({
											...this.state,
											filtro: {
												...this.state.filtro,
												dias_descarga: value
											}
										});
									}} />
								
								<div style={{ display: 'flex', marginTop: 8, marginLeft: 10, flexWrap: 'wrap' }}>
									{/*
									<div style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', flexWrap: 'wrap', width: 60, height: 60 }}>
										<div style={{ display: 'flex', alignItems: 'center', marginRight: 8 }} title='Abertos'>
											<img src={iconeViagemAberta} style={{ marginRight: 4, width: 18, height: 20 }}></img>

											<div class="custom-control custom-switch">
												<input type="checkbox" class='custom-control-input' id='customSwitch3'
													checked={this.state.filtro.aberto}
													onChange={data => this.setState({ ...this.state, filtro: { ...this.state.filtro, aberto: !this.state.filtro.aberto } })} />
												<label class="custom-control-label" for="customSwitch3"></label>
											</div>
										</div>
										<div style={{ display: 'flex', alignItems: 'center' }} title='Finalizados'>
											<i class='fas fa-flag-checkered' style={{ marginRight: 4, width: 18 }}></i>
											<div class="custom-control custom-switch">
												<input type="checkbox" class='custom-control-input' id='customSwitch4'
													checked={this.state.filtro.finalizado}
													onChange={data => this.setState({ ...this.state, filtro: { ...this.state.filtro, finalizado: !this.state.filtro.finalizado } })} />
												<label class="custom-control-label" for="customSwitch4"></label>
											</div>
										</div>
									</div>
									*/}
									<div style={{ width: 390 }}>
										<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
											onClick={() => {
												this.props.getLista(this.state.filtro, true);												
											}}>
											<i class='fas fa-sync-alt'></i> Atualizar
										</a>
										{/*<ExcelFile
											filename={'LINEHAUL RS - RN'}
											element={
												<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
													<i class='fas fa-file-excel'></i> Exportar
												</a>
											}>
											{this.montarExcel(listaFiltrada)}
										</ExcelFile>*/}
										<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
											onClick={() => {
												// this.montarExcel(listaFiltrada);
												this.props.gerarExcel();
											}}>
											<i class='fas fa-file-excel'></i> Exportar
										</a>
										<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
											onClick={() => {
												this.props.gerarPdfListadoEmbarqueLocalizado(listaFiltrada);
											}}>
											<i class='fas fa-file'></i> Embarque
										</a>
										<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
											onClick={() => {
												this.props.gerarPdfListadoEmbarqueRN(listaFiltrada, this.state.filtro.dias_descarga);
											}}>
											<i class='fas fa-file'></i> Emb. RN
										</a>
										<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
											onClick={() => {
												this.props.gerarPdfEstadoEmbarqueFrontera(listaFiltrada);
											}}>
											<i class='fas fa-file-pdf'></i> Fronteira
										</a>
									</div>
								</div>

							</Row>
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody paddingTop={0}>
					<div 
						style={{ 
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1574 ? `${window.innerHeight - 250}px`
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 165}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 165}px`
										: `${window.innerHeight - 165}px`
									)
								)
							)
						}}>
						<Table responsive border striped alturaFixa 
								maxHeight={window.innerWidth < 768 ? '100%' : window.innerWidth < 768 ? '100%' : (
									window.innerWidth < 1574 ? `${window.innerHeight - 250}px`
									: (
										window.innerWidth < 1799 
										? `${window.innerHeight - 165}px`
										: (
											window.innerWidth < 4000 
											? `${window.innerHeight - 165}px`
											: `${window.innerHeight - 165}px`
										)
									)
								)}>
							<THead>

								<Tr backgroundColor={'#1F3066'} color={'#ffffff'}>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ rumo: this.getNovaOrdenacao(this.state.ordenacao.rumo)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Rumo {this.getIconeOrdenacao(this.state.ordenacao.rumo)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ viagem: this.getNovaOrdenacao(this.state.ordenacao.viagem)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Viagem {this.getIconeOrdenacao(this.state.ordenacao.viagem)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ identificador: this.getNovaOrdenacao(this.state.ordenacao.identificador)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Identificador {this.getIconeOrdenacao(this.state.ordenacao.identificador)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ documento: this.getNovaOrdenacao(this.state.ordenacao.documento)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>CRT {this.getIconeOrdenacao(this.state.ordenacao.documento)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={400} onClick={() => this.setNovaOrdenacao({ fatura_comercial: this.getNovaOrdenacao(this.state.ordenacao.fatura_comercial)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Fatura Comercial {this.getIconeOrdenacao(this.state.ordenacao.fatura_comercial)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ ptas: this.getNovaOrdenacao(this.state.ordenacao.ptas)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>PTAS {this.getIconeOrdenacao(this.state.ordenacao.ptas)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ adicional_ruteo: this.getNovaOrdenacao(this.state.ordenacao.adicional_ruteo)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Adicional ou Ruteo {this.getIconeOrdenacao(this.state.ordenacao.adicional_ruteo)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ cidade_origem: this.getNovaOrdenacao(this.state.ordenacao.cidade_origem)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Cidade de Origem {this.getIconeOrdenacao(this.state.ordenacao.cidade_origem)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ kmm: this.getNovaOrdenacao(this.state.ordenacao.kmm)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>KMM {this.getIconeOrdenacao(this.state.ordenacao.kmm)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ duns_number_coleta: this.getNovaOrdenacao(this.state.ordenacao.duns_number_coleta)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>DUNS {this.getIconeOrdenacao(this.state.ordenacao.duns_number_coleta)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={300} onClick={() => this.setNovaOrdenacao({ nome_cliente_origem: this.getNovaOrdenacao(this.state.ordenacao.nome_cliente_origem)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Origem {this.getIconeOrdenacao(this.state.ordenacao.nome_cliente_origem)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={200} onClick={() => this.setNovaOrdenacao({ operacao: this.getNovaOrdenacao(this.state.ordenacao.operacao)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Operação {this.getIconeOrdenacao(this.state.ordenacao.operacao)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ peso_bruto: this.getNovaOrdenacao(this.state.ordenacao.peso_bruto)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Peso Bruto {this.getIconeOrdenacao(this.state.ordenacao.peso_bruto)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ volume: this.getNovaOrdenacao(this.state.ordenacao.volume)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Volume {this.getIconeOrdenacao(this.state.ordenacao.volume)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ cavalo: this.getNovaOrdenacao(this.state.ordenacao.cavalo)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Cavalo {this.getIconeOrdenacao(this.state.ordenacao.cavalo)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ carreta: this.getNovaOrdenacao(this.state.ordenacao.carreta)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Carreta {this.getIconeOrdenacao(this.state.ordenacao.carreta)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_previsao: this.getNovaOrdenacao(this.state.ordenacao.datahora_previsao)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Programação {this.getIconeOrdenacao(this.state.ordenacao.datahora_previsao)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_chegada_carga: this.getNovaOrdenacao(this.state.ordenacao.datahora_chegada_carga)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Chegada na Carga {this.getIconeOrdenacao(this.state.ordenacao.datahora_chegada_carga)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_saida_programada: this.getNovaOrdenacao(this.state.ordenacao.datahora_saida_programada)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Saída Programada {this.getIconeOrdenacao(this.state.ordenacao.datahora_saida_programada)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_saida_carga: this.getNovaOrdenacao(this.state.ordenacao.datahora_saida_carga)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Saida da Carga {this.getIconeOrdenacao(this.state.ordenacao.datahora_saida_carga)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_chegada_troca_nota: this.getNovaOrdenacao(this.state.ordenacao.datahora_chegada_troca_nota)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Chegada Troca de Nota {this.getIconeOrdenacao(this.state.ordenacao.datahora_chegada_troca_nota)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_saida_troca_nota: this.getNovaOrdenacao(this.state.ordenacao.datahora_saida_troca_nota)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Saída Troca de Nota {this.getIconeOrdenacao(this.state.ordenacao.datahora_saida_troca_nota)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ primeiro_transito: this.getNovaOrdenacao(this.state.ordenacao.primeiro_transito)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Primeiro Trânsito {this.getIconeOrdenacao(this.state.ordenacao.primeiro_transito)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={300} onClick={() => this.setNovaOrdenacao({ fronteira: this.getNovaOrdenacao(this.state.ordenacao.fronteira)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Fronteira {this.getIconeOrdenacao(this.state.ordenacao.fronteira)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_previsao_fronteira: this.getNovaOrdenacao(this.state.ordenacao.datahora_previsao_fronteira)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Previsão de Fronteira {this.getIconeOrdenacao(this.state.ordenacao.datahora_previsao_fronteira)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_chegada_fronteira: this.getNovaOrdenacao(this.state.ordenacao.datahora_chegada_fronteira)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Chegada na Fronteira {this.getIconeOrdenacao(this.state.ordenacao.datahora_chegada_fronteira)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_ingresso_fronteira: this.getNovaOrdenacao(this.state.ordenacao.datahora_ingresso_fronteira)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Ingresso na Fronteira {this.getIconeOrdenacao(this.state.ordenacao.datahora_ingresso_fronteira)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_liberacao_br: this.getNovaOrdenacao(this.state.ordenacao.datahora_liberacao_br)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Liberação BR {this.getIconeOrdenacao(this.state.ordenacao.datahora_liberacao_br)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={80} onClick={() => this.setNovaOrdenacao({ canal: this.getNovaOrdenacao(this.state.ordenacao.canal)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Canal {this.getIconeOrdenacao(this.state.ordenacao.canal)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_apresentacao_ar: this.getNovaOrdenacao(this.state.ordenacao.datahora_apresentacao_ar)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Apresentação AR {this.getIconeOrdenacao(this.state.ordenacao.datahora_apresentacao_ar)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_liberacao_ar: this.getNovaOrdenacao(this.state.ordenacao.datahora_liberacao_ar)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Liberação AR {this.getIconeOrdenacao(this.state.ordenacao.datahora_liberacao_ar)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_saida_guarita: this.getNovaOrdenacao(this.state.ordenacao.datahora_saida_guarita)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Saída da Guarita {this.getIconeOrdenacao(this.state.ordenacao.datahora_saida_guarita)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ segundo_transito: this.getNovaOrdenacao(this.state.ordenacao.segundo_transito)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Segundo Trânsito {this.getIconeOrdenacao(this.state.ordenacao.segundo_transito)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_previsao_chegada_gm: this.getNovaOrdenacao(this.state.ordenacao.datahora_previsao_chegada_gm)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Previsao GM {this.getIconeOrdenacao(this.state.ordenacao.datahora_previsao_chegada_gm)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_chegada_aduana: this.getNovaOrdenacao(this.state.ordenacao.datahora_chegada_aduana)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Chegada na Aduana {this.getIconeOrdenacao(this.state.ordenacao.datahora_chegada_aduana)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_entrega_documento: this.getNovaOrdenacao(this.state.ordenacao.datahora_entrega_documento)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Entrega do Documento {this.getIconeOrdenacao(this.state.ordenacao.datahora_entrega_documento)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_liberacao_aduana: this.getNovaOrdenacao(this.state.ordenacao.datahora_liberacao_aduana)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Liberação da Aduana {this.getIconeOrdenacao(this.state.ordenacao.datahora_liberacao_aduana)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_chegada_descarga: this.getNovaOrdenacao(this.state.ordenacao.datahora_chegada_descarga)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Chegada na Descarga {this.getIconeOrdenacao(this.state.ordenacao.datahora_chegada_descarga)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ datahora_saida_descarga: this.getNovaOrdenacao(this.state.ordenacao.datahora_saida_descarga)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Saída da Descarga {this.getIconeOrdenacao(this.state.ordenacao.datahora_saida_descarga)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={300} onClick={() => this.setNovaOrdenacao({ observacao: this.getNovaOrdenacao(this.state.ordenacao.observacao)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Observação {this.getIconeOrdenacao(this.state.ordenacao.observacao)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ mic: this.getNovaOrdenacao(this.state.ordenacao.mic)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>MIC {this.getIconeOrdenacao(this.state.ordenacao.mic)}</Th>
									<Th paddingTop={2} paddingBottom={2} minWidth={120} onClick={() => this.setNovaOrdenacao({ rout_id: this.getNovaOrdenacao(this.state.ordenacao.rout_id)})} sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Route_ID {this.getIconeOrdenacao(this.state.ordenacao.rout_id)}</Th>
								</Tr>
							</THead>
							<TBody>
								{listaFiltrada.map((item, i) => {
									
									return (
										<>
											<Tr key={item.solicitacao_carga_id} 
												backgroundColor={i % 2 == 0 ? '#ffffff' : '#f5f5f5'} >
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{item.rumo}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{item.viagem}</Td>
												<Td onClick={() => setLinhaSelecionada(item.identificador)} minWidth={10} color={'#000'} alignCenter small>{item.identificador}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{item.documento}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={400} color={'#000'} alignCenter small>{item.fatura_comercial}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{item.ptas}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{item.adicional_ruteo}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{item.cidade_origem}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{item.kmm}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{item.duns_number_coleta}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={300} color={'#000'} alignCenter small>{item.nome_cliente_origem}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={200} color={'#000'} alignCenter small>{item.operacao}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{FormatUtils.formatarValorTela(item.peso_bruto, 2)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{FormatUtils.formatarValorTela(item.volume, 2)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{item.cavalo}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{item.carreta}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada_carga)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida_programada)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida_carga)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada_troca_nota)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida_troca_nota)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{item.primeiro_transito}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={300} color={'#000'} alignCenter small>{item.fronteira}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_fronteira)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada_fronteira)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_ingresso_fronteira)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_liberacao_br)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>
													{item.canal &&
													<div
														style={{
															backgroundColor: item.canal == 'ROJO' ? '#e53935' : (item.canal == 'NARANJA' ? '#fb8c00' : '#43a047'),
															color: '#fff',
															padding: '2px 8px',
															borderRadius: 12,
															fontSize: 10,
															fontWeight: 600,
															display: 'inline-block',
															textAlign: 'center'
														}}>
														{item.canal}
													</div>}
												</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_apresentacao_ar)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_liberacao_ar)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida_guarita)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{item.segundo_transito}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_chegada_gm)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada_aduana)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_entrega_documento)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_liberacao_aduana)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada_descarga)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida_descarga)}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={300} color={'#000'} alignCenter small>{item.observacao}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{item.mic}</Td>
												<Td onClick={() => setLinhaSelecionada(item.solicitacao_carga_id)} minWidth={10} color={'#000'} alignCenter small>{item.rout_id}</Td>
											</Tr>
										</>
									)
								})}
							</TBody>
						</Table>
					</div>

				</ContentCardBody>
			</ContentCard>
		);
	}

	montarExcel(listaFiltrada) {

		Excel.exportar('Linehaul', 
			[{
				atributo: 'rumo',
				nome: 'Emp',
				largura: 10,
				formato: null
			}, {
				atributo: 'viagem',
				nome: 'Viag',
				largura: 10,
				formato: null
			}/*, {
				atributo: 'identificador',
				nome: 'Identificador',
				largura: 10,
				formato: null
			}*/, {
				atributo: 'documento',
				nome: 'CRT',
				largura: 15,
				formato: null
			}, {
				atributo: 'fatura_comercial',
				nome: 'Fat_Comercial',
				largura: 100,
				formato: null
			}, {
				atributo: 'ptas',
				nome: 'PTAS',
				largura: 10,
				formato: null
			}, {
				atributo: 'cidade_origem',
				nome: 'Ciudad_Orig',
				largura: 30,
				formato: null
			}, {
				atributo: 'kmm',
				nome: 'KMM',
				largura: 10,
				formato: null
			}, {
				atributo: 'duns_number_coleta',
				nome: 'DUNS',
				largura: 10,
				formato: null
			}, {
				atributo: 'nome_cliente_origem',
				nome: 'Origem',
				largura: 30,
				formato: null
			}, {
				atributo: 'operacao',
				nome: 'Operação',
				largura: 30,
				formato: null
			}, {
				atributo: 'peso_bruto',
				nome: 'Peso_Bruto',
				largura: 10,
				formato: Excel.FORMATOS.numeroDecimal2
			}, {
				atributo: 'volume',
				nome: 'M³',
				largura: 10,
				formato: Excel.FORMATOS.numeroDecimal2
			}, {
				atributo: 'cavalo',
				nome: 'Cavalo',
				largura: 10,
				formato: null
			}, {
				atributo: 'carreta',
				nome: 'Carreta',
				largura: 10,
				formato: null
			}, {
				atributo: 'datahora_previsao',
				nome: 'Programação',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'datahora_chegada_carga',
				nome: 'Cheg_Carga',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'datahora_saida_programada',
				nome: 'Saíd_Programada',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'datahora_saida_carga',
				nome: 'Saíd_Carga',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'datahora_chegada_troca_nota',
				nome: 'Cheg_Troca_Nota',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'datahora_saida_troca_nota',
				nome: 'Saíd_Troca_Nota',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'primeiro_transito',
				nome: '1_Trânsito',
				largura: 17,
				formato: Excel.FORMATOS.padrao
			}, {
				atributo: 'fronteira',
				nome: 'Front_Cruze',
				largura: 30,
				formato: null
			}, {
				atributo: 'datahora_previsao_fronteira',
				nome: 'Prev_Cheg_Front',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'datahora_chegada_fronteira',
				nome: 'Cheg_Front',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'datahora_ingresso_fronteira',
				nome: 'Ingresso',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'datahora_liberacao_br',
				nome: 'Liberação_BR',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'canal',
				nome: 'Canal',
				largura: 10,
				formato: null
			}, {
				atributo: 'datahora_apresentacao_ar',
				nome: 'Apresentação_AR',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'datahora_liberacao_ar',
				nome: 'Liberação_AR',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'datahora_saida_guarita',
				nome: 'Saíd_Guarita',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'segundo_transito',
				nome: '2_Trânsito',
				largura: 17,
				formato: Excel.FORMATOS.padrao
			}, {
				atributo: 'datahora_previsao_chegada_gm',
				nome: 'Prev_Cheg_GM',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'datahora_chegada_aduana',
				nome: 'Cheg_Aduana',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'datahora_entrega_documento',
				nome: 'Entreg_Documento',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'datahora_liberacao_aduana',
				nome: 'Lib_Aduana',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'datahora_chegada_descarga',
				nome: 'Cheg_Descarga',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'datahora_saida_descarga',
				nome: 'Saíd_Descarga',
				largura: 17,
				formato: Excel.FORMATOS.dataHora
			}, {
				atributo: 'observacao',
				nome: 'Observação',
				largura: 50,
				formato: null
			}, {
				atributo: 'mic',
				nome: 'MIC/DTA',
				largura: 20,
				formato: null
			}, {
				atributo: 'rout_id',
				nome: 'Route_ID',
				largura: 40,
				formato: null
			}
		],
			listaFiltrada.map(item => ({
				...item,
				documento: (item.documento || '').split('.').join('')
			}))
		);

		
		/*
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		return (
			<ExcelSheet data={listaFiltrada.map(item => ({
				...item,
				documento: (item.documento || '').split('.').join(''),
				datahora_previsao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao),
				datahora_chegada_carga: DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada_carga),
				datahora_saida_programada: DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida_programada),
				datahora_saida_carga: DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida_carga),
				datahora_chegada_troca_nota: DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada_troca_nota),
				datahora_saida_troca_nota: DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida_troca_nota),
				datahora_primeiro_transito: DateFormat.formatarDataHoraSqlParaTela(item.datahora_primeiro_transito),
				datahora_previsao_fronteira: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_fronteira),
				datahora_chegada_fronteira: DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada_fronteira),
				datahora_ingresso_fronteira: DateFormat.formatarDataHoraSqlParaTela(item.datahora_ingresso_fronteira),
				datahora_liberacao_br: DateFormat.formatarDataHoraSqlParaTela(item.datahora_liberacao_br),
				datahora_apresentacao_ar: DateFormat.formatarDataHoraSqlParaTela(item.datahora_apresentacao_ar),
				datahora_liberacao_ar: DateFormat.formatarDataHoraSqlParaTela(item.datahora_liberacao_ar),
				datahora_saida_guarita: DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida_guarita),
				datahora_segundo_transito: DateFormat.formatarDataHoraSqlParaTela(item.datahora_segundo_transito),
				datahora_previsao_chegada_gm: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_chegada_gm),
				datahora_chegada_aduana: DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada_aduana),
				datahora_entrega_documento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_entrega_documento),
				datahora_liberacao_aduana: DateFormat.formatarDataHoraSqlParaTela(item.datahora_liberacao_aduana),
				datahora_chegada_descarga: DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada_descarga),
				datahora_saida_descarga: DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida_descarga),
				peso_bruto: parseFloat(item.peso_bruto),
				volume: parseFloat(item.volume)
			}))} name='LINEHAUL RS - RN'>
				<ExcelColumn label='Emp' value='rumo'/>
				<ExcelColumn label='Viag' value='viagem'/>
				<ExcelColumn label='CRT' value='documento'/>
				<ExcelColumn label='Fat_Comercial' value='fatura_comercial'/>
				<ExcelColumn label='PTAS' value='ptas'/>
				<ExcelColumn label='Adicional_ou_Ruteo' value='adicional_ruteo'/>
				<ExcelColumn label='Ciudad_Orig' value='cidade_origem'/>
				<ExcelColumn label='KMM' value='kmm'/>
				<ExcelColumn label='DUNS' value='duns_number_coleta'/>
				<ExcelColumn label='Origem' value='nome_cliente_origem'/>
				<ExcelColumn label='Operação' value='operacao'/>
				<ExcelColumn label='Peso_Bruto' value='peso_bruto' type='number'/>
				<ExcelColumn label='M³' value='volume' type='number'/>
				<ExcelColumn label='Cavalo' value='cavalo'/>
				<ExcelColumn label='Carreta' value='carreta'/>
				<ExcelColumn label='Programação' value='datahora_previsao'/>
				<ExcelColumn label='Cheg_Carga' value='datahora_chegada_carga'/>
				<ExcelColumn label='Saíd_Programada' value='datahora_saida_programada'/>
				<ExcelColumn label='Saíd_Carga' value='datahora_saida_carga'/>
				<ExcelColumn label='Cheg_Troca_Nota' value='datahora_chegada_troca_nota'/>
				<ExcelColumn label='Saíd_Troca_Nota' value='datahora_saida_troca_nota'/>
				<ExcelColumn label='1_Trânsito' value='datahora_primeiro_transito'/>
				<ExcelColumn label='Front_Cruze' value='fronteira'/>
				<ExcelColumn label='Prev_Cheg_Front' value='datahora_previsao_fronteira'/>
				<ExcelColumn label='Cheg_Front' value='datahora_chegada_fronteira'/>
				<ExcelColumn label='Ingresso' value='datahora_ingresso_fronteira'/>
				<ExcelColumn label='Liberação_BR' value='datahora_liberacao_br'/>
				<ExcelColumn label='Canal' value='canal'/>
				<ExcelColumn label='Apresentação_AR' value='datahora_apresentacao_ar'/>
				<ExcelColumn label='Liberação_AR' value='datahora_liberacao_ar'/>
				<ExcelColumn label='Saíd_Guarita' value='datahora_saida_guarita'/>
				<ExcelColumn label='2_Trânsito' value='datahora_segundo_transito'/>
				<ExcelColumn label='Prev_Cheg_GM' value='datahora_previsao_chegada_gm'/>
				<ExcelColumn label='Cheg_Aduana' value='datahora_chegada_aduana'/>
				<ExcelColumn label='Entreg_Documento' value='datahora_entrega_documento'/>
				<ExcelColumn label='Lib_Aduana' value='datahora_liberacao_aduana'/>
				<ExcelColumn label='Cheg_Descarga' value='datahora_chegada_descarga'/>
				<ExcelColumn label='Saíd_Descarga' value='datahora_saida_descarga'/>
				<ExcelColumn label='Observação' value='observacao'/>
				<ExcelColumn label='MIC/DTA' value='mic'/>
			</ExcelSheet>
		);
		*/
	}

	controleFavoritos(idShippingCode) {
		let lista = JSON.parse(Cookies.get('shippingsFavoritos') || '[]');

		if (this.isFavorito(idShippingCode)) {
			lista = lista.filter(item => item != idShippingCode);
		} else {
			lista.push(idShippingCode);
		}

		lista = lista.filter(item => (this.props.lista || []).filter(shipping => shipping.shipping_code_id == item).length);

		this.setState({ ...this.state, listaFavoritos: lista });

		Cookies.set('shippingsFavoritos', JSON.stringify(lista), { expires: 15 });
	}

	isFavorito(idShippingCode) {
		return (this.state.listaFavoritos || []).filter(shipping => shipping == idShippingCode).length > 0;
	}
	
	modalShipping() {

		const qtdSolicitacoes = this.props.listaSolicitacoes.filter(item => item.shipping_code_id == this.state.registroModal.shipping_code_id).length;
		let mostrarColunaSolicitacao = false;
		this.props.listaPrevisoes.filter(item => item.shipping_code_id == this.state.registroModal.shipping_code_id).map(item => {
			if ((item.solicitacoes || []).filter(sol => sol).length != qtdSolicitacoes) {
				mostrarColunaSolicitacao = true;
			}
		});

		let solicitacao = this.props.listaSolicitacoes.filter(item => item.shipping_code_id == this.state.registroModal.shipping_code_id)[0] || {};

		let acessoCliente = this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cliente;

        return (
			<>
				<div className="modal-backdrop fade show" />
				<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
					<div class='modal-dialog modal-xl'>
						<div class='modal-content'>
							<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
								<h4 class='modal-title'>Shipping Code: {this.state.registroModal.shipping_code_id} <i class={this.isFavorito(this.state.registroModal.shipping_code_id) ? 'fas fa-star' : 'far fa-star'} title={this.isFavorito(this.state.registroModal.shipping_code_id) ? 'Remover dos favoritos' : 'Adicionar aos favoritos'} onClick={() => this.controleFavoritos(this.state.registroModal.shipping_code_id)} style={{ marginLeft: 8, cursor: 'pointer' }}></i></h4>
								{/*<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, registroModal: null })}>
									<span aria-hidden='true' style={{ color: '#fff', fontSize: 32 }}>×</span>
								</button>*/}

								<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
									{/* Botão da câmera */}
									{(!acessoCliente && this.props.usuarioCarregado && this.props.usuarioCarregado.arquivo_reports) &&
										<button
											type='button'
											className='close custom-close'
											onClick={() => {
												this.setState({
													...this.state,
													registroModal: null,
													registroArquivos: { ...this.state.registroModal }
												})
											}}
											style={{
												padding: 0,
												marginRight: 12,
												display: "flex",
												alignItems: "center",
												background: "transparent",
												border: "none",
												cursor: "pointer",
												color: "#fff"
											}} >
											<i className='fas fa-images' style={{ fontSize: 28 }}></i>

											{this.props.listaArquivos.length > 0 && (
												<span style={{
													marginLeft: 2,
													fontSize: 14,
													fontWeight: 'bold',
													marginTop: -28
												}}>
													{this.props.listaArquivos.length}
												</span>
											)}
										</button>}

									{/* Botão padrão de fechar */}
									<button
										type='button'
										className='close custom-close'
										data-dismiss='modal'
										aria-label='Close'
										style={{
											marginLeft: 4
										}}
										onClick={() => this.setState({ ...this.state, registroModal: null })} >
										<span aria-hidden='true' style={{ color: '#fff', fontSize: 36 }}>×</span>
									</button>
								</div>
							</div>
							<div class='modal-body' style={{ height: window.innerHeight * 0.8, overflowY: 'scroll' }}>

								<h6>Placas</h6>

								<Table responsive>
									<THead>
										<Tr>
											<Th alignCenter>Solicitação</Th>
											<Th alignCenter>Cavalo</Th>
											<Th alignCenter>Carreta</Th>
											<Th alignCenter>Motorista</Th>
											<Th alignCenter>Local</Th>
											<Th alignCenter>Latitude/Longitude</Th>
											<Th alignCenter>Status</Th>
										</Tr>
									</THead>
									<TBody>
										{this.props.lista.filter(item => item.solicitacao_carga_id == this.state.registroModal.solicitacao_carga_id).map(item => (
											<Tr key={item.solicitacao_carga_id}>
												<Td alignCenter small>{item.solicitacao_carga_id || ''}</Td>
												<Td alignCenter small>{item.cavalo || ''}</Td>
												<Td alignCenter small>{item.carreta || ''}</Td>
												<Td alignCenter small>{item.motorista || ''}</Td>
												<Td alignCenter small>{item.veiculo_referencia || ''}</Td>
												<Td alignCenter small>
													{(item.veiculo_latitude && item.veiculo_longitude) &&
													<a target='blank' href={`https://www.google.com/maps/place/${item.veiculo_latitude},${item.veiculo_longitude}`}>
														{item.veiculo_latitude}, {item.veiculo_longitude}
													</a>}
												</Td>
												<Td alignCenter small>{item.veiculo_status || ''}</Td>
											</Tr>
										))}
									</TBody>
								</Table>

								<Grid cols="12 12 12 12">
									<div style={{ width: "100%", height: 500 }}>
										<MapLeaflet
											coordenadas={this.props.lista.filter(item => item.shipping_code_id == this.state.registroModal.shipping_code_id && item.veiculo_latitude && item.veiculo_longitude)
												.map(item => ({
													id: item.solicitacao_carga_id,
													titulo: item.cavalo,
													latitude: item.veiculo_latitude,
													longitude: item.veiculo_longitude,
													direcao: this.state.registroModal.rumo == 'RS' ? 'S' : 'N'
												}))}
											zoom={4}
											latitude={'-28.381875'}
											longitude={'-53.937355'}
											onChange={(coordenadas) => {
											}}
										/>
									</div>
								</Grid>

							</div>
							{/*<div class='modal-footer justify-content-between'>
								<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
								<button type='button' class='btn btn-primary'
									onClick={() => this.setState({ ...this.state, registroModal: null })}>Fechar</button>
							</div>*/}
						</div>
					</div>
				</div>
			</>
        );
    }

	modalOcorrencia() {

		const qtdSolicitacoes = this.props.listaSolicitacoes.filter(item => item.shipping_code_id == this.state.registroModalOcorrencia.shipping_code_id).length;
		let mostrarColunaSolicitacao = false;
		this.props.listaPrevisoes.filter(item => item.shipping_code_id == this.state.registroModalOcorrencia.shipping_code_id).map(item => {
			if ((item.solicitacoes || []).filter(sol => sol).length != qtdSolicitacoes) {
				mostrarColunaSolicitacao = true;
			}
		});

		let solicitacao = this.props.listaSolicitacoes.filter(item => item.shipping_code_id == this.state.registroModalOcorrencia.shipping_code_id)[0] || {};

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
							<h4 class='modal-title'>Shipping Code: {this.state.registroModalOcorrencia.shipping_code_id}</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, registroModalOcorrencia: null })}>
								<span aria-hidden='true' style={{ color: '#fff', fontSize: 32 }}>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ overflowY: 'scroll', marginBottom: 80 }}>

							<h6>Ocorrências</h6>

							<Table responsive>
								<THead>
									<Tr>
										<Th alignCenter>Tipo</Th>
										<Th alignCenter>Responsável</Th>
										<Th alignCenter>Início</Th>
										<Th alignCenter>Fim</Th>
										<Th alignCenter>Descrição</Th>
										<Th alignCenter>Usuário</Th>
									</Tr>
								</THead>
								<TBody>
									{this.props.listaOcorrencias.filter(item => item.shipping_code_id == this.state.registroModalOcorrencia.shipping_code_id).map(item => (
										<Tr key={item.id_ocorrencia}>
											<Td alignCenter small>{item.descricao_tipo_ocorrencia || ''}</Td>
											<Td alignCenter small>{item.responsabilidade == 0 ? 'Cliente' : 'Letsara'}</Td>
											<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.data_inicio)}</Td>
											<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.data_termino)}</Td>
											<Td alignCenter small>{item.comentario || ''}</Td>
											<Td alignCenter small>{item.usuario_inclusao || ''}</Td>
										</Tr>
									))}
								</TBody>
							</Table>

						</div>
					</div>
				</div>
			</div>
        );
    }

	modalContatos() {

        return (
			<div class='modal fade show' id='modal-md' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-md'>
					<div class='modal-content'>
						<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
							<h4 class='modal-title'>Contatos</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, contatosModal: null })}>
								<span aria-hidden='true' style={{ color: '#fff', fontSize: 32 }}>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ overflowY: 'scroll' }}>

							<h6>Placas</h6>

							<Table responsive>
								<THead>
									<Tr>
										<Th alignCenter>Nome</Th>
										<Th alignCenter>Celular</Th>
										<Th alignCenter>WhatsApp</Th>
									</Tr>
								</THead>
								<TBody>
									{(this.props.usuarioCarregado.contatos || []).map(item => (
										<Tr key={item.id}>
											<Td alignCenter>{item.nome}</Td>
											<Td alignCenter>{FormatUtils.formatarTelefone(item.telefone)}</Td>
											<Td alignCenter>
												<a class='btn btn-success' target='blank' href={`https://api.whatsapp.com/send?phone=+55${item.telefone}&text=${encodeURI(`Olá ${item.nome}`)}`}>
													<i style={{ fontSize: 24 }} class='fab fa-whatsapp'></i>
												</a>
											</Td>
										</Tr>
									))}
								</TBody>
							</Table>
						</div>
					</div>
				</div>
			</div>
        );
    }

	modalArquivos() {

		if (!this.state.registroArquivos) {
			return;
		}

		return (
			<>
				<div className="modal-backdrop fade show" />
				<div class='modal fade show'
					id='modal-xl'
					style={{ display: 'block' }}
					aria-modal='true'>
					<div class='modal-dialog modal-xl'>
						<div class='modal-content'>
							<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
								<h4 class='modal-title'>Shipping Code: {this.state.registroArquivos.shipping_code_id}</h4>
								<button type='button' class='close custom-close' data-dismiss='modal' aria-label='Close'
									onClick={() => this.setState({ ...this.state, registroArquivos: null })}>
									<span aria-hidden='true' style={{ color: '#fff', fontSize: 32, marginRight: 4 }}>×</span>
								</button>
							</div>
							<div class='modal-body' style={{ height: window.innerHeight * 0.8, overflowY: 'scroll', padding: 2 }}>
								<ReportsArquivo
									shipping={this.state.registroArquivos.shipping_code_id}
									solicitacao={this.state.registroArquivos.solicitacao_carga_id} />
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	modoTela: state.linehaul.modoTela,
	aguardando: state.linehaul.aguardando,
	lista: state.linehaul.lista.map(item => {
		if (state.auth.usuario && state.auth.usuario.id == 214) { //Demonstração
			return {
				...item,
				negociador: 'DEMONSTRAÇÃO',
				nome_remetente_sol: 'DEMONSTRAÇÃO',
				nome_destinatario_sol: 'DEMONSTRAÇÃO',
				veiculo_referencia: 'DEMONSTRAÇÃO',
				observacao: 'DEMONSTRAÇÃO'
			}
		} else {
			return item;
		}
	}),
	listaFronteiras: state.linehaul.listaFronteiras,
	listaNegociadores: state.linehaul.listaNegociadores,
	listaRumos: state.linehaul.listaRumos,
	listaFarolAtraso: state.linehaul.listaFarolAtraso,
	listaOcorrencias: state.linehaul.listaOcorrencias,
	listaSolicitacoes: state.linehaul.listaSolicitacoes,
	listaPrevisoes: state.linehaul.listaPrevisoes,
	listaEventos: state.linehaul.listaEventos,
	listaPrevisoesEventos: state.linehaul.listaPrevisoesEventos,
	listaOperacoes: state.linehaul.listaOperacoes,
	filtro: state.linehaul.filtro,
	listaArquivos: state.reportsArquivo.lista,
	listaDiasDescarga: state.linehaul.listaDiasDescarga
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, getListaFronteiras, getListaNegociadores, getListaOperacoes, getLista, getListaOcorrencias,
	registrarAcesso, getListaArquivos, gerarPdfListadoEmbarqueLocalizado, gerarPdfListadoEmbarqueRN, 
	gerarPdfEstadoEmbarqueFrontera, gerarExcel
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Linehaul);
